import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service'; // Ajusta la ruta a tu AuthService

// Este resolvedor no devuelve datos, solo se completa cuando la verificación ha terminado.
export const authInitializerResolver: ResolveFn<boolean> = (route, state) => {
    const authService = inject(AuthService);

    // Convertimos el signal que indica si la verificación terminó en un Observable
    return toObservable(authService.authStatusChecked).pipe(
        // Usamos filter() para esperar hasta que el valor sea `true`
        filter(isChecked => isChecked === true),
        // Usamos take(1) para que el observable se complete después de emitir el primer `true`
        take(1)
    );
};
